import { TOLGEE_GLOBALS } from 'utils'

export default [
  {
    label: 'Under 60 seconds',
    URLValue: 'to1',
    queryValue: {
      lt: 60,
    },
    tolgeeKey: TOLGEE_GLOBALS.to1,
  },
  {
    label: '1 to 3 minutes',
    URLValue: 'from1to3',
    queryValue: {
      gte: 60,
      lte: 180,
    },
    tolgeeKey: TOLGEE_GLOBALS.from1to3,
  },
  {
    label: '3 minutes and above',
    URLValue: 'from3',
    queryValue: {
      gt: 180,
    },
    tolgeeKey: TOLGEE_GLOBALS.from3,
  },
]
